var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-404" }, [
      _c("div", { staticClass: "sybold" }, [_vm._v("未找到页面")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }